import assest from "../../json/assest";
import { Box, Button, Dialog } from "@mui/material";
// import Image from 'next/image'
import React from "react";
import CopywriterDashboardFeedbackModal from "../../components/CopywriterDashboard/CopywriterDashboard/CopywriterDashboardFeedbackModal/CopywriterDashboardFeedbackModal";

const UserCopyWriterFooter = (props) => {
  const [isActive, setIsActive] = React.useState(false);
  const handleClick = (event) => {
    setIsActive((current) => !current);
  };

  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClickClose = () => {
    setOpen(false);
  };
  const handleClose = (value) => {
    setOpen(false);
  };
  return (
    <>
      {props?.footerChatBtn && (
        <footer className="userFooter">
          <Box className={isActive ? "ftChat open-chat" : "ftChat"} >
            <img
              src={assest.chatFooter}
              width={38}
              height={33}
              alt="chatIcon"
              onClick={handleClick}
            />
            <Button onClick={handleClickOpen}>Share Your Thoughts </Button>
          </Box>
        </footer>
      )}
      {/* ***************feedbackModal************** */}

      <Dialog
        onClose={handleClose}
        open={open}
        className="copywriterDashboardfeedbackModal"
        sx={{
          "& .MuiDialog-container": {
            alignItems: "flex-start",
            marginTop: "72px",
          },
        }}
      >
        <CopywriterDashboardFeedbackModal   setOpen={handleClickClose}/>
        <Box className="closeFeedbackModal">
          <Button onClick={handleClickClose}>{/* <UserCrossIcon /> */}</Button>
        </Box>
      </Dialog>
    </>
  );
};

export default UserCopyWriterFooter;
